import React from 'react';
import { Input, InputNumber, InputNumberProps, Radio as AntRadio, SelectProps, Select } from 'antd';
import { Field } from 'formik';
import TextArea from 'antd/es/input/TextArea';

type Props = InputNumberProps & {
  name?: string;
};

type PropsSelect = SelectProps & {
  name?: string;
};

export const NumberInput = ({ name, ...props }: Props) => {
  return (
    <Field
      name={name}
      render={({ field, form }: { field: any; form: any }) => (
        <InputNumber
          {...field}
          {...props}
          value={field.value}
          onChange={(e) => form.setFieldValue(name, e)}
          onBlur={field.onBlur}
          name={name}
          status={form.errors[name!] ? 'error' : ''}
          help={form.errors[name!] ? form.errors[name!] : ''}
        />
      )}
    />
  );
};

export const TextInput = ({ name, ...props }: Props) => {
  return (
    <Field
      name={name}
      render={({ field, form }: { field: any; form: any }) => (
        <Input
          {...field}
          {...props}
          value={field.value}
          onChange={(e) => form.setFieldValue(name, e.target.value)}
          onBlur={field.onBlur}
          name={name}
          status={form.errors[name!] ? 'error' : ''}
          help={form.errors[name!] ? form.errors[name!] : ''}
        />
      )}
    />
  );
};

export const TextInputPassword = ({ name, ...props }: Props) => {
  return (
    <Field
      name={name}
      render={({ field, form }: { field: any; form: any }) => (
        <Input.Password
          {...field}
          {...props}
          value={field.value}
          onChange={(e) => form.setFieldValue(name, e.target.value)}
          onBlur={field.onBlur}
          name={name}
          status={form.errors[name!] ? 'error' : ''}
          help={form.errors[name!] ? form.errors[name!] : ''}
        />
      )}
    />
  );
};

export const TextAreaInput = ({ name, ...props }: Props) => {
  return (
    <Field
      style={{ flex: 1 }}
      name={name}
      render={({ field, form }: { field: any; form: any }) => (
        <TextArea
          {...field}
          {...props}
          value={field.value}
          onChange={(e: any) => form.setFieldValue(name, e?.target?.value)}
          onBlur={field.onBlur}
          name={name}
          status={form.errors[name!] ? 'error' : ''}
          help={form.errors[name!] ? form.errors[name!] : ''}
        />
      )}
    />
  );
};

export const Radio = ({ name, ...props }: Props) => {
  return (
    <Field
      name={name}
      render={({ field, form }: { field: any; form: any }) => (
        <AntRadio
          {...field}
          {...props}
          value={field.value}
          onChange={(e: any) => form.setFieldValue(name, e?.target?.value)}
          onBlur={field.onBlur}
          name={name}
          status={form.errors[name!] ? 'error' : ''}
          help={form.errors[name!] ? form.errors[name!] : ''}
        />
      )}
    />
  );
};

export const RadioGroupInput = ({ name, options }: { name: string; options: any }) => (
  <Field name={name}>
    {({ field, form }: any) => (
      <AntRadio.Group
        {...field}
        value={field.value}
        onChange={(e) => form.setFieldValue(name, e.target.value)}
      >
        {options.map((opt: any) => (
          <AntRadio key={opt.code} value={opt.code}>
            {opt.name}
          </AntRadio>
        ))}
      </AntRadio.Group>
    )}
  </Field>
);

export const Group = ({ name, children, ...props }: Props) => {
  return (
    <Field
      name={name}
      render={({ field, form }: { field: any; form: any }) => (
        <AntRadio.Group
          {...field}
          {...props}
          value={field.value}
          onChange={(e: any) => form.setFieldValue(name, e?.target?.value)}
          onBlur={field.onBlur}
          name={name}
          status={form.errors[name!] ? 'error' : ''}
          help={form.errors[name!] ? form.errors[name!] : ''}
        >
          {children}
        </AntRadio.Group>
      )}
    />
  );
};

export const SelectInput = ({ name, options, placeholder, ...props }: PropsSelect) => {
  return (
    <Field
      name={name}
      render={({ field, form }: { field: any; form: any }) => (
        <Select
          {...field}
          {...props}
          value={field.value}
          onChange={(e) => form.setFieldValue(name, e)}
          options={options}
          placeholder={placeholder}
        />
      )}
    />
  );
};

//  <Select
//     value={values.manufacturerCountry}
//     onChange={(e) => setFieldValue('manufacturerCountry', e)}
//     options={getOption(general?.manufacturerCountries)}
//     placeholder="Улс"
//   />
